(function() {
    'use strict';

    class MiniProfileService {
        constructor(ICM_CONTACT_SOURCE_SERVICE_API_KEY, mwBannerService, $translate) {
            this.ICM_CONTACT_SOURCE_SERVICE_API_KEY = ICM_CONTACT_SOURCE_SERVICE_API_KEY;
            this.mwBannerService = mwBannerService;
            this.$translate = $translate;
            this.openBanners = null;
            this.miniProfileId = '';
        }

        openMiniProfile(contactId, preventDefault = false) {
            try {
                this.miniProfileId = contactId;
                const chromeContent = document.querySelector('mi-app-chrome-content');
                const miniProfileHeader = document.querySelector('icm-mini-profile-header');
                miniProfileHeader.setContactId(contactId);
                chromeContent.openDrawer();
                if (preventDefault) {
                    let e = window.event;
                    e.preventDefault();
                }
            } catch (error) {
                try {
                    this.OpenErrorBanner(contactId);
                    let e = window.event;
                    e.preventDefault();
                } catch (error) {
                    console.error(error);
                }
            }
        }

        OpenErrorBanner(contactId) {
            const chromeContent = document.querySelector('mi-app-chrome-content');
            chromeContent.closeDrawer();
            
            this.mwBannerService.open({
                bindToController: true,
                template: `
                <mw-banner type="'alert'" on-close="$ctrl.close()">
                    {{$ctrl.alertBannerText}}
                    <mw-banner-actions>
                        <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.TryToOpenMiniAgain()">
                            {{$ctrl.tryAgainText}}
                        </md-button>
                        <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.ViewProfile()">
                            {{$ctrl.ViewProfileText}}
                        </md-button>
                    </mw-banner-actions>
                </mw-banner>
                `,
                controller: class BannerPanel {
                    constructor(mdPanelRef, $translate, MiniProfileService, $window, $scope, IRM_BASE_URL) {
                        'ngInject';
                        this.$translate = $translate;
                        this.mdPanelRef = mdPanelRef;
                        this.MiniProfileService = MiniProfileService;
                        this.$window = $window;
                        this.$scope = $scope;
                        this.IRM_BASE_URL = IRM_BASE_URL;

                        this.alertBannerText = this.$translate.instant('icm-search__mini-profile-failed-to-open-error--body');
                        this.tryAgainText = this.$translate.instant('icm-search__mini-profile-failed-to-open-error--try-again');
                        this.ViewProfileText = this.$translate.instant('icm-search__mini-profile-failed-to-open-error--view-contact');
                    }
                    TryToOpenMiniAgain() {
                        this.mdPanelRef.close();
                        this.MiniProfileService.openMiniProfile(contactId, false);
                    }

                    ViewProfile() {
                        this.contactUrl = this.IRM_BASE_URL + '/contact/' + contactId;
                        this.$window.open(this.contactUrl);
                    }

                    close() {
                        this.mdPanelRef.close();
                        this.MiniProfileService.miniProfileId = '';
                    }
                },
                controllerAs: '$ctrl',
            }).then(newBanner =>{
                this.closeMiniProfileBanner(newBanner);
            });
        }

        closeMiniProfileBanner(newBanner = null) {
            if (this.openBanners !== null) {
                if (newBanner !== null) {
                    this.openBanners.close();
                    this.openBanners = newBanner;
                }
                else {
                    this.openBanners.close();
                    this.openBanners = null;
                }
            }
            else{
                this.openBanners = newBanner;
            }
        }

        closeMiniProfile() {
            const miniProfileHeader = document.querySelector('icm-mini-profile-header');
            miniProfileHeader.setContactId('');
            this.miniProfileId = '';
            const chromeContent = document.querySelector('mi-app-chrome-content');
            chromeContent.closeDrawer();
        }
    }  
    
    angular
        .module('MW.Influencers.MiniProfileService', [])
        .service('MiniProfileService', [
            'ICM_CONTACT_SOURCE_SERVICE_API_KEY',
            'mwBannerService',
            '$translate',
            MiniProfileService
        ]);
})();